export const countriesList = [
  {
    code: "+55",
    name: "Brasil",
    flag: "https://flagcdn.com/w40/br.png",
    acronym: "BR",
  },
  {
    code: "+1",
    name: "Estados Unidos",
    flag: "https://flagcdn.com/w40/us.png",
    acronym: "US",
  },
  {
    code: "+54",
    name: "Argentina",
    flag: "https://flagcdn.com/w40/ar.png",
    acronym: "AR",
  },
  {
    code: "+52",
    name: "México",
    flag: "https://flagcdn.com/w40/mx.png",
    acronym: "MX",
  },
  {
    code: "+57",
    name: "Colômbia",
    flag: "https://flagcdn.com/w40/co.png",
    acronym: "CO",
  },
  {
    code: "+58",
    name: "Venezuela",
    flag: "https://flagcdn.com/w40/ve.png",
    acronym: "VE",
  },
  {
    code: "+56",
    name: "Chile",
    flag: "https://flagcdn.com/w40/cl.png",
    acronym: "CL",
  },
  {
    code: "+51",
    name: "Peru",
    flag: "https://flagcdn.com/w40/pe.png",
    acronym: "PE",
  },
  {
    code: "+504",
    name: "Honduras",
    flag: "https://flagcdn.com/w40/hn.png",
    acronym: "HN",
  },
  {
    code: "+503",
    name: "El Salvador",
    flag: "https://flagcdn.com/w40/sv.png",
    acronym: "SV",
  },
  {
    code: "+502",
    name: "Guatemala",
    flag: "https://flagcdn.com/w40/gt.png",
    acronym: "GT",
  },
  {
    code: "+591",
    name: "Bolívia",
    flag: "https://flagcdn.com/w40/bo.png",
    acronym: "BO",
  },
  {
    code: "+592",
    name: "Guiana",
    flag: "https://flagcdn.com/w40/gy.png",
    acronym: "GY",
  },
  {
    code: "+593",
    name: "Equador",
    flag: "https://flagcdn.com/w40/ec.png",
    acronym: "EC",
  },
  {
    code: "+595",
    name: "Paraguai",
    flag: "https://flagcdn.com/w40/py.png",
    acronym: "PY",
  },
  {
    code: "+598",
    name: "Uruguai",
    flag: "https://flagcdn.com/w40/uy.png",
    acronym: "UY",
  },
  {
    code: "+501",
    name: "Belize",
    flag: "https://flagcdn.com/w40/bz.png",
    acronym: "BZ",
  },
  {
    code: "+505",
    name: "Nicarágua",
    flag: "https://flagcdn.com/w40/ni.png",
    acronym: "NI",
  },
  {
    code: "+506",
    name: "Costa Rica",
    flag: "https://flagcdn.com/w40/cr.png",
    acronym: "CR",
  },
  {
    code: "+507",
    name: "Panamá",
    flag: "https://flagcdn.com/w40/pa.png",
    acronym: "PA",
  },
  {
    code: "+53",
    name: "Cuba",
    flag: "https://flagcdn.com/w40/cu.png",
    acronym: "CU",
  },
  {
    code: "+1",
    name: "Canadá",
    flag: "https://flagcdn.com/w40/ca.png",
    acronym: "CA",
  },
  {
    code: "+1",
    name: "Jamaica",
    flag: "https://flagcdn.com/w40/jm.png",
    acronym: "JM",
  },
  {
    code: "+1",
    name: "República Dominicana",
    flag: "https://flagcdn.com/w40/do.png",
    acronym: "DO",
  },
  {
    code: "+44",
    name: "Reino Unido",
    flag: "https://flagcdn.com/w40/gb.png",
    acronym: "GB",
  },
  {
    code: "+33",
    name: "França",
    flag: "https://flagcdn.com/w40/fr.png",
    acronym: "FR",
  },
  {
    code: "+49",
    name: "Alemanha",
    flag: "https://flagcdn.com/w40/de.png",
    acronym: "DE",
  },
  {
    code: "+34",
    name: "Espanha",
    flag: "https://flagcdn.com/w40/es.png",
    acronym: "ES",
  },
  {
    code: "+39",
    name: "Itália",
    flag: "https://flagcdn.com/w40/it.png",
    acronym: "IT",
  },
  {
    code: "+7",
    name: "Rússia",
    flag: "https://flagcdn.com/w40/ru.png",
    acronym: "RU",
  },
  {
    code: "+43",
    name: "Áustria",
    flag: "https://flagcdn.com/w40/at.png",
    acronym: "AT",
  },
  {
    code: "+41",
    name: "Suíça",
    flag: "https://flagcdn.com/w40/ch.png",
    acronym: "CH",
  },
  {
    code: "+31",
    name: "Países Baixos",
    flag: "https://flagcdn.com/w40/nl.png",
    acronym: "NL",
  },
  {
    code: "+32",
    name: "Bélgica",
    flag: "https://flagcdn.com/w40/be.png",
    acronym: "BE",
  },
  {
    code: "+30",
    name: "Grécia",
    flag: "https://flagcdn.com/w40/gr.png",
    acronym: "GR",
  },
  {
    code: "+46",
    name: "Suécia",
    flag: "https://flagcdn.com/w40/se.png",
    acronym: "SE",
  },
  {
    code: "+47",
    name: "Noruega",
    flag: "https://flagcdn.com/w40/no.png",
    acronym: "NO",
  },
  {
    code: "+48",
    name: "Polônia",
    flag: "https://flagcdn.com/w40/pl.png",
    acronym: "PL",
  },
  {
    code: "+45",
    name: "Dinamarca",
    flag: "https://flagcdn.com/w40/dk.png",
    acronym: "DK",
  },
  {
    code: "+358",
    name: "Finlândia",
    flag: "https://flagcdn.com/w40/fi.png",
    acronym: "FI",
  },
  {
    code: "+351",
    name: "Portugal",
    flag: "https://flagcdn.com/w40/pt.png",
    acronym: "PT",
  },
  {
    code: "+353",
    name: "Irlanda",
    flag: "https://flagcdn.com/w40/ie.png",
    acronym: "IE",
  },
  {
    code: "+90",
    name: "Turquia",
    flag: "https://flagcdn.com/w40/tr.png",
    acronym: "TR",
  },
  {
    code: "+91",
    name: "Índia",
    flag: "https://flagcdn.com/w40/in.png",
    acronym: "IN",
  },
  {
    code: "+81",
    name: "Japão",
    flag: "https://flagcdn.com/w40/jp.png",
    acronym: "JP",
  },
  {
    code: "+86",
    name: "China",
    flag: "https://flagcdn.com/w40/cn.png",
    acronym: "CN",
  },
  {
    code: "+92",
    name: "Paquistão",
    flag: "https://flagcdn.com/w40/pk.png",
    acronym: "PK",
  },
  {
    code: "+62",
    name: "Indonésia",
    flag: "https://flagcdn.com/w40/id.png",
    acronym: "ID",
  },
  {
    code: "+63",
    name: "Filipinas",
    flag: "https://flagcdn.com/w40/ph.png",
    acronym: "PH",
  },
  {
    code: "+82",
    name: "Coreia do Sul",
    flag: "https://flagcdn.com/w40/kr.png",
    acronym: "KR",
  },
  {
    code: "+94",
    name: "Sri Lanka",
    flag: "https://flagcdn.com/w40/lk.png",
    acronym: "LK",
  },
  {
    code: "+95",
    name: "Mianmar",
    flag: "https://flagcdn.com/w40/mm.png",
    acronym: "MM",
  },
  {
    code: "+66",
    name: "Tailândia",
    flag: "https://flagcdn.com/w40/th.png",
    acronym: "TH",
  },
  {
    code: "+965",
    name: "Kuwait",
    flag: "https://flagcdn.com/w40/kw.png",
    acronym: "KW",
  },
  {
    code: "+971",
    name: "Emirados Árabes Unidos",
    flag: "https://flagcdn.com/w40/ae.png",
    acronym: "AE",
  },
  {
    code: "+98",
    name: "Irã",
    flag: "https://flagcdn.com/w40/ir.png",
    acronym: "IR",
  },
  {
    code: "+60",
    name: "Malásia",
    flag: "https://flagcdn.com/w40/my.png",
    acronym: "MY",
  },
  {
    code: "+961",
    name: "Líbano",
    flag: "https://flagcdn.com/w40/lb.png",
    acronym: "LB",
  },
  {
    code: "+61",
    name: "Austrália",
    flag: "https://flagcdn.com/w40/au.png",
    acronym: "AU",
  },
  {
    code: "+64",
    name: "Nova Zelândia",
    flag: "https://flagcdn.com/w40/nz.png",
    acronym: "NZ",
  },
  {
    code: "+675",
    name: "Papua Nova Guiné",
    flag: "https://flagcdn.com/w40/pg.png",
    acronym: "PG",
  },
  {
    code: "+679",
    name: "Fiji",
    flag: "https://flagcdn.com/w40/fj.png",
    acronym: "FJ",
  },
  {
    code: "+682",
    name: "Ilhas Cook",
    flag: "https://flagcdn.com/w40/ck.png",
    acronym: "CK",
  },
  {
    code: "+687",
    name: "Nova Caledônia",
    flag: "https://flagcdn.com/w40/nc.png",
    acronym: "NC",
  },
  {
    code: "+27",
    name: "África do Sul",
    flag: "https://flagcdn.com/w40/za.png",
    acronym: "ZA",
  },
  {
    code: "+234",
    name: "Nigéria",
    flag: "https://flagcdn.com/w40/ng.png",
    acronym: "NG",
  },
  {
    code: "+20",
    name: "Egito",
    flag: "https://flagcdn.com/w40/eg.png",
    acronym: "EG",
  },
  {
    code: "+212",
    name: "Marrocos",
    flag: "https://flagcdn.com/w40/ma.png",
    acronym: "MA",
  },
  {
    code: "+254",
    name: "Quênia",
    flag: "https://flagcdn.com/w40/ke.png",
    acronym: "KE",
  },
  {
    code: "+251",
    name: "Etiópia",
    flag: "https://flagcdn.com/w40/et.png",
    acronym: "ET",
  },
  {
    code: "+213",
    name: "Argélia",
    flag: "https://flagcdn.com/w40/dz.png",
    acronym: "DZ",
  },
  {
    code: "+256",
    name: "Uganda",
    flag: "https://flagcdn.com/w40/ug.png",
    acronym: "UG",
  },
  {
    code: "+258",
    name: "Moçambique",
    flag: "https://flagcdn.com/w40/mz.png",
    acronym: "MZ",
  },
  {
    code: "+221",
    name: "Senegal",
    flag: "https://flagcdn.com/w40/sn.png",
    acronym: "SN",
  },
];
